import React from 'react';
import { Lock, Send, Code } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const FeaturesSection = () => {
  const features = [
    {
      icon: Lock,
      title: 'Maximum privacy protection',
      description: 'Guarded Mail Box is registered and operates under Swiss jurisdiction, ensuring your information benefits from the world\'s most comprehensive privacy regulations and legal protections.',
      bgColor: 'bg-indigo-100',
      iconColor: 'text-indigo-600',
    },
    {
      icon: Send,
      title: 'Seamless migration process',
      description: 'With our Express Transfer feature, you can effortlessly transition from any email service to Guarded Mail Box. Import all your messages, labels, contacts, and calendar events with automated forwarding for incoming mail.',
      bgColor: 'bg-amber-100',
      iconColor: 'text-amber-600',
    },
    {
      icon: Code,
      title: 'Transparent and verified security',
      description: 'Our platform is built on open-source principles and undergoes continuous independent security audits. This ensures complete transparency and accountability in protecting your digital communications.',
      bgColor: 'bg-indigo-100',
      iconColor: 'text-indigo-600',
    },
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <Card 
              key={index} 
              className="border-0 shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 bg-white overflow-hidden group"
            >
              <CardContent className="p-8 space-y-6">
                <div className={`w-16 h-16 ${feature.bgColor} rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                  <feature.icon className={`h-8 w-8 ${feature.iconColor}`} strokeWidth={2} />
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 leading-tight">
                  {feature.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>

                {/* Decorative bottom accent */}
                <div className="pt-4">
                  <div className={`h-1 w-0 group-hover:w-full ${feature.iconColor === 'text-indigo-600' ? 'bg-indigo-600' : 'bg-amber-500'} transition-all duration-500`}></div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;